//import { galaxoStats } from '../../../src/assets/js/src/scripts-galaxo.js';

function init() {

	$('.nav-galaxo').on('mousedown', 'a', function(e) {

		var $link = $(this);
		var title = $link.find('.btn__text').text();

		e.preventDefault();

		// $(document).trigger('galaxoStats', ['nav', $(this).find('.btn__text').text()]);

		/*
		galaxoStats.send('nav', title).always(function() {
			setTimeout(function() {
				if (!$link.is('.btn--search')) {
					document.location.href = $link.attr('href');
				}
			}, 150);
		});
		*/

		if (!$link.is('.btn--search')) {
			document.location.href = $link.attr('href');
		}

	});

}

export default {
	init: init
};
